module.exports = __webpack_public_path__ + "static/media/loginImg.254e71df.webp";